import React from 'react';
import { ModalContent } from 'fronton-react';
import { ModalHeader, Typography } from 'common/components';
import {
  newKitchenUtpSectionModalContent,
  newKitchenUtpSectionModalText,
} from '../../new-kitchen-utp-section-styles';

export const Factories: React.FC = () => (
  <>
    <ModalHeader title="Более 48&nbsp;фабрик" />
    <ModalContent className={newKitchenUtpSectionModalContent}>
      <Typography className={newKitchenUtpSectionModalText} variant="m" size="body_long" adaptive={false}>
        Мы&nbsp;применяем в&nbsp;своей работе современные технологии и&nbsp;используют только
        высококачественные материалы.
      </Typography>
      <Typography variant="m" size="body_long" adaptive={false}>
        Мы&nbsp;также внимательно следим за&nbsp;каждым этапом производства&nbsp;&mdash; от&nbsp;разработки
        до&nbsp;финальной реализации.
      </Typography>
    </ModalContent>
  </>
);
